import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Card, Typography, message } from "antd";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FormField } from "../components/FormFields";
import { FormProvider } from "../components/FormProvider";
import { useAuth } from "../hooks/useAuth";
import { loginSchema, type LoginFormData } from "../schemas";
import { apiClient } from "../utils/api";

const { Title, Text } = Typography;

const Login: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const onSubmit = async (data: LoginFormData) => {
    setLoading(true);
    try {
      const response = await apiClient.login(data);

      if (response.success && response.user) {
        await login(response.user);
      } else {
        await login({ id: "1", username: data.username, role: "admin" });
      }

      message.success("Login successful!");
      navigate("/");
    } catch (error) {
      console.error("Login error:", error);
      message.error("Login failed. Please check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #1f2937 0%, #111827 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "1rem",
      }}
    >
      <Card
        style={{
          width: "100%",
          maxWidth: 400,
          boxShadow:
            "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "2rem" }}>
          <Title level={2} style={{ color: "#6366f1", marginBottom: "0.5rem" }}>
            WCS Admin
          </Title>
          <Text type="secondary">Carta Warehouse Control System</Text>
        </div>

        <FormProvider
          schema={loginSchema}
          onSubmit={onSubmit}
          defaultValues={{
            username: "",
            password: "",
          }}
          className="login-form"
        >
          <FormField
            name="username"
            placeholder="Username"
            prefix={<UserOutlined />}
            required
          />

          <FormField
            name="password"
            type="password"
            placeholder="Password"
            prefix={<LockOutlined />}
            required
          />

          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            block
            style={{
              background: "#6366f1",
              borderColor: "#6366f1",
              height: "48px",
              fontSize: "16px",
              marginTop: "16px",
            }}
          >
            {loading ? "Signing in..." : "Sign In"}
          </Button>
        </FormProvider>

        <div style={{ textAlign: "center", marginTop: "1rem" }}>
          <Text type="secondary" style={{ fontSize: "12px" }}>
            Access to this system is restricted to authorized personnel only.
          </Text>
        </div>
      </Card>
    </div>
  );
};

export default Login;
